<template>
    <div>
        <table v-if="waybillModel.internationalExpressFlag && !isAppleWaybill" class="top">
            <tr>
                <td>
                    <p class="text">国际直邮</p>
                </td>
                <td class="img-wrapper">
                    <img :src="certifiedShippingImgUrl" alt="国际直邮图片" />
                </td>
            </tr>
        </table>
        <p v-else-if="isAppleWaybill && !waybillModel.internationalExpressFlag" class="onlyApple">
            <span class="gray appleText">苹果客服专线</span>{{ appleServiceLine }}
        </p>
        <table v-else-if="waybillModel.internationalExpressFlag && isAppleWaybill" class="top">
            <tr>
                <td>
                    <p class="text">国际直邮</p>
                    <p><span class="gray appleText">苹果客服专线</span>{{ appleServiceLine }}</p>
                </td>
                <td class="img-wrapper">
                    <img :src="certifiedShippingImgUrl" alt="国际直邮图片" />
                </td>
            </tr>
        </table>
        <div class="tab">
            <div class="clearfix waybill-no">
                <p class="fl">
                    <span class="gray no">运单号</span>
                    <span>{{ waybillModel.id }}</span>
                </p>
                <p class="fr">{{ waybillModel.productName || '顺丰标快' }}</p>
            </div>
            <div class="clearfix waybill-locations">
                <div class="locations fl">
                    <span>{{ waybillModel.originOld }}</span>
                    <icon name="arrow-right"></icon>
                    <span>{{ waybillModel.destinationOld }}</span>
                </div>
                <div v-if="getStatusByOpcode.type === 'signed' || getStatusByOpcode.type === 'invalid'" class="status fr">
                    <span :class="['express-state', getStatusByOpcode.type]">{{ getStatusByOpcode.name }}</span>
                </div>
                <div v-else class="fr">
                    <table class="delivery-time">
                        <tr v-if="getDeliveryTm">
                            <td>
                                <p class="gray">预计送达</p>
                                <p>{{ getDeliveryTm.date }}{{ getDeliveryTm.time }}</p>
                            </td>
                        </tr>
                        <tr v-else>
                            <td><p class="gray">预计送达时间：无</p></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <p v-if="reminder" class="reminder" v-text="reminder"></p>
        <p v-if="parentWaybillIsPrompt" class="reminder yellow-reminder">
            此单由寄件方通过多个始发地分开发货，共含{{ waybillModel.childSet.length }}件，目前暂未到齐，请您耐心等待。
        </p>
    </div>
</template>

<script>
import moment from 'moment'
import ajax from '../../../api/ajax'
import { productCodeMap } from './config'
export default {
    name: 'WaybillInfo',
    props: {
        waybillModel: {
            type: Object,
            default() {
                return {}
            }
        },
        getStatusByOpcode: {
            type: Object,
            default() {
                return {}
            }
        },
        isRootMenu: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            reminder: '', // 营运异常事件提醒
            parentWaybillIsPrompt: false // 母单路由是否显示提示语
        }
    },
    computed: {
        // 国际直邮图片
        certifiedShippingImgUrl() {
            return require(`../../../assets/images/certified_shipping/${this.waybillModel.internationalExpressFlag}.png`)
        },

        // 苹果件
        isAppleWaybill() {
            const no = this.waybillModel.id.toString()
            return no.startsWith('960') || no.startsWith('SF960')
        },

        // 苹果件客服电话
        appleServiceLine() {
            const destinationOld = this.waybillModel.destinationOld.toUpperCase()
            if (destinationOld === 'SINGAPORE' || destinationOld === '新加坡') {
                return '1800-3111-111（限新加坡）'
            } else if (destinationOld === 'HONG KONG' || destinationOld === '香港') {
                return '00852-27300273（限香港）'
            } else if (destinationOld === 'TAIWAN' || destinationOld === '台湾' || destinationOld === '台灣') {
                return '0800-088830（限台湾座机）02-21926063（台湾座机以外）'
            } else {
                return '4001288853（限大陆）'
            }
        },

        // 预计送达文案显示
        getDeliveryTm() {
            const model = this.waybillModel
            if (model.signed === false && model.pisDeliveryTm && model.pisDeliveryTm.queryPromise && model.destination) {
                const dt = model.pisDeliveryTm.queryPromise
                const deliveryDateTime = dt.substring(0, dt.indexOf('+') >= 0 ? dt.indexOf('+') : dt.length)
                if (model.delay) {
                    return null
                } else {
                    const obj = {
                        time: moment(deliveryDateTime).format('HH:mm'),
                        datetime: moment(deliveryDateTime).format('YYYY.MM.DD HH:mm')
                    }
                    moment.locale('zh-cn')
                    obj.date = moment(deliveryDateTime).format('MMM Do').replace(/\s/, '')
                    return obj
                }
            } else {
                return null
            }
        }
    },
    created() {
        if (this.getStatusByOpcode.type !== 'signed') {
            this.queryOrderControlList()
            // 屏蔽老包的营运异常
            // this.getReminder()
            // this.getExpressServiceEvent()
        }

        if (this.isRootMenu && this.waybillModel.childSet.length > 0) {
            this.getParentWaybillPromptContent()
        }
    },
    methods: {
        // 新包营运提醒
        queryOrderControlList() {
            const senderAddress = {
                countyCode: '',
                cityCode: this.waybillModel.sourceCityCode,
                locationCode: this.waybillModel.sourceCityCode,
                contactTel: '',
                contactPhone: ''
            }
            const receiverAddress = {
                countyCode: '',
                cityCode: this.waybillModel.destCityCode,
                locationCode: this.waybillModel.destCityCode
            }
            const productObj = {
                cargoTypeCode: this.waybillModel.cargoTypeCode,
                expressTypeCode: this.waybillModel.expressTypeCode,
                limitTypeCode: this.waybillModel.limitTypeCode,
                productCode: this.waybillModel.productCode
            }
            const normalProductCode = productCodeMap[productObj.productCode] || 'SE0001'
            const data = {
                controlType: 1,
                channelCode: 'MOBILE.OWF',
                waybillNo: this.waybillModel.id || '',
                srcZoneCode: senderAddress.locationCode,
                consignedTm: this.waybillModel.routes[this.waybillModel.routes.length - 1].scanDateTime,
                srcAddress: '',
                srcDivisionCode: senderAddress.countyCode || senderAddress.cityCode,
                srcCityCode: senderAddress.cityCode,
                destBpsInfoList: [
                    {
                        index: 0,
                        customerType: 1,
                        customerCode: senderAddress.contactTel || senderAddress.contactPhone || '999999999',
                        destZoneCode: receiverAddress.locationCode,
                        productCode: normalProductCode,
                        limitTypeCode: productObj.limitTypeCode,
                        cargoTypeCode: productObj.cargoTypeCode,
                        expressTypeCode: productObj.expressTypeCode || productObj.businessCode,
                        destAddress: '',
                        destDivisionCode: receiverAddress.countyCode || receiverAddress.cityCode,
                        destCityCode: receiverAddress.cityCode,
                        totalWeight: 1
                    }
                ]
            }
            ajax.queryOrderControl({
                data
            }).then(({ data: resultApi }) => {
                const { code, result } = resultApi
                if (Number(code) === 0) {
                    if (result && result.length > 0 && result[0].bpsControlInfo) {
                        const { notificationMsg = '' } = result[0].bpsControlInfo
                        this.reminder = notificationMsg
                    }
                }
            })
        },
        // 营运异常事件提醒
        getReminder() {
            ajax.queryOrderExceptionInfo({
                params: {
                    sourceCityCode: this.waybillModel.sourceCityCode || '',
                    destCityCode: this.waybillModel.destCityCode || ''
                }
            }).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    const result = res.data.result
                    this.reminder = result.consigneeMessage || result.shipperMessage
                }
            })
        },
        // 获取营运事件异常提醒
        getExpressServiceEvent() {
            const { sourceCityCode, destCityCode, id, productCode, routes = [], limitTypeCode, cargoTypeCode, expressTypeCode } = this.waybillModel
            if (sourceCityCode && destCityCode) {
                ajax.bpsQueryOrderExceptionInfo({
                    params: {
                        srcCityCode: sourceCityCode || '',
                        destCityCode: destCityCode || '',
                        waybillNo: id || ''
                    },
                    data: {
                        productCode: productCode || '',
                        consignedTm: routes[0] && routes[0].scanDateTime,
                        srcZoneCode: sourceCityCode,
                        destZoneCode: destCityCode,
                        limitTypeCode,
                        cargoTypeCode,
                        expressTypeCode
                    }
                }).then(({ data }) => {
                    if (data.code === 0 && data.result.notificationMsg) {
                        this.$toast(data.result.notificationMsg)
                    }
                })
            }
        },
        // 母单路由显示提示语
        getParentWaybillPromptContent() {
            ajax.parentWaybillIsPrompt({
                data: {
                    parentWaybill: {
                        parentWaybillNo: this.waybillModel.id,
                        sourceCityCode: this.waybillModel.sourceCityCode,
                        sign: this.waybillModel.signed
                    },
                    childWaybillNoList: this.waybillModel.childSet
                }
            }).then(({ data }) => {
                if (data.code === 0 && data.result) {
                    this.parentWaybillIsPrompt = data.result.prompt
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.top {
    width: 100%;
    margin: 10px 0;
    .text {
        font-size: 45px;
        font-weight: 600;
    }
    .img-wrapper {
        text-align: right;
    }
    img {
        width: 150px;
        height: 150px;
    }
}
.appleText {
    margin-right: 20px;
}
.onlyApple {
    margin-bottom: 20px;
}
.tab {
    box-shadow: 0 15px 60px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 20px;
}
.waybill-no {
    border-bottom: 1px solid $gray-lighter;
    margin: 0 -20px;
    padding: 0 20px 10px;
    .no {
        margin-right: 20px;
    }
}
.waybill-locations {
    margin-top: 20px;
    .locations {
        font-size: 35px;
        font-weight: 600;
    }
}
.icon-arrow-right {
    display: inline;
    color: $gray;
    width: 100px;
    margin: 0 30px;
}
.express-state {
    display: block;
    margin-top: 18px;
    padding: 10px 20px;
    border-radius: 50px;
    background: $bg-color;
    color: $gray;
    &.signed {
        color: $red;
    }
}
.delivery-time {
    font-size: 25px;
    height: 100px;
    .time {
        font-size: 60px;
        transform: scaleY(1.8);
    }
}
.reminder {
    background: $bg-color;
    color: $red;
    padding: 10px 15px;
    margin-top: 35px;
    border-radius: 4px;
}
.yellow-reminder {
    background: #fbf4dd;
    color: #f48944;
}
</style>



// WEBPACK FOOTER //
// src/pages/waybill/waybillDetail/waybill-info.vue